module.exports = __webpack_public_path__ + "static/media/add-texture.2286844c.gif";